import { createFileRoute } from '@tanstack/react-router';
import { OVERVIEW_ROUTE } from '../area-routes';
import { PlaceOverview } from '../area-view';

export const Route = createFileRoute('/settings/')({
  ...OVERVIEW_ROUTE,
  component: () => <PlaceOverview base="/settings" />,
});
